export default function NotificationService($log, $timeout, utils) {
	"ngInject";

	let listeners = [],
		nextListenerId = 1;

	const NotificationService = {
		type: {INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error"},

		notify: (type, message, details, log) => {
			let notification = {
				type,
				message,
				details: utils.toArray(details),
				log
			};
			notifyListeners(notification);
		},
		exception: (vm, msg = "pros-maps.error.general") => (
			(ex, cause) => {
				if (vm) {
					vm.errored = true;
				}
				NotificationService.error(msg, null, ex + (cause ? ` (caused by "${cause}")` : "") + ex.stack);
			}
		),

		listen: (type, callback) => {
			if (!callback) {
				callback = type;
				type = null;
			}

			let listener = {id: nextListenerId++, callback, type};
			listeners.push(listener);
			return listener.id;
		},
		unlisten: (listenerId) => {
			for (let i = 0; i < listeners.length; i++) {
				let listener = listeners[i];
				if (listener.id === listenerId) {
					listeners.splice(i, 1);
					break;
				}
			}
		}
	};

	angular.forEach(NotificationService.type, (type) => {
		NotificationService[type] = (message, details, log) => (
			NotificationService.notify(type, message, details, log)
		);
	});


	function notifyListeners(notification) {
		listeners.forEach((listener) => {
			if (!listener.type || notification.type === listener.type) {
				$timeout(() => {
					listener.callback(notification);
				});
			}
		});

		if (notification.message) {
			let method = getLogMethod(notification.type);
			$log[method](notification.message, notification.details, notification.log);
		}
	}


	function getLogMethod(type) {
		switch (type) {
			case NotificationService.type.ERROR:
				return "error";
			case NotificationService.type.WARNING:
				return "warn";
			case NotificationService.type.INFO:
			default:
				return "info";
		}
	}


	return NotificationService;
}
